import { render } from "./AgendaGridItem.vue?vue&type=template&id=f263247e&scoped=true"
import script from "./AgendaGridItem.vue?vue&type=script&lang=js"
export * from "./AgendaGridItem.vue?vue&type=script&lang=js"

import "./AgendaGridItem.vue?vue&type=style&index=0&id=f263247e&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f263247e"]])

export default __exports__